import styles from "./style.postcss";
import DOMPurify from 'dompurify';
import React, { Component } from "react";
import { PageCard, Checkbox, TextArea, Icon, testClass } from "omni-common-ui";
import ReactGA from "react-ga4";
import PropTypes from "prop-types";
import classnames from "classnames";

class CICCategoryCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFreeTextInEdit: false,
      tempFreeText: null,
    };
  }

  _changeFreeText(val) {
    this.setState({ tempFreeText: val });
  }

  _editFreeText(freeText) {
    this.setState({ isFreeTextInEdit: true, tempFreeText: freeText });
  }

  _onBlureFreeText() {
    const { tempFreeText } = this.state;
    this.props.onFreeTextChange(tempFreeText);
    this.setState({ isFreeTextInEdit: false });
  }

  _renderFreeText(item) {
    const { isEdit } = this.props;
    const { tempFreeText, isFreeTextInEdit } = this.state;

    const itemClassName = isEdit
      ? styles.CICCategoryCard_categoryItem_edit
      : styles.CICCategoryCard_categoryItem;

    const headerClassName = classnames(styles.CICCategoryCard_freeText_header, {
      [styles.CICCategoryCard_freeText_header_edit]: isEdit,
    });

    const checkBoxId = `${item.cicCategoryId}-${item.cicCategoryItemId}`;

    return (
      <div className={styles.CICCategoryCard_freeText}>
        <div className={headerClassName}>
          <div className={styles.CICCategoryCard_freeText_header_title}>
            Free Text
          </div>
          {isEdit && !isFreeTextInEdit && (
            <Icon
              id="edit"
              onClick={() => this._editFreeText(item.cicCategoryItemName)}
            />
          )}
        </div>
        <label className={itemClassName} key={checkBoxId} htmlFor={checkBoxId}>
          {isEdit ? (
            <Checkbox
              id={checkBoxId}
              checked={item.isChecked}
              onChange={(checkBoxStatus) =>
                this._handleCheckBoxChecked(
                  item.cicCategoryId,
                  item.cicCategoryItemId,
                  checkBoxStatus,
                )
              }
            />
          ) : (
            ""
          )}
          {isFreeTextInEdit ? (
            <TextArea
              value={tempFreeText}
              onChange={(e) => this._changeFreeText(e.target.value)}
              maxLength={1000}
              onBlur={() => this._onBlureFreeText()}
              autoFocus
            />
          ) : (
            <span className={styles.CICCategoryCard_categoryItem_content}>
              {item.cicCategoryItemName}
            </span>
          )}
        </label>
      </div>
    );
  }

  _renderCategories() {
    if (this.props.categoriesList) {
      return (
        <div className={styles.CICCategoryCard_categories}>
          {this.props.categoriesList.map((categoryItem) => {
            if (categoryItem.cicCategoryItemId === 0) {
              return this._renderFreeText(categoryItem);
            }
            return this._renderCategoryItem(categoryItem);
          })}
        </div>
      );
    }
  }

  _renderCategoryItem(item) {
    const { isEdit } = this.props;
    const id = item.cicCategoryId;
    const itemClassName = isEdit
      ? styles.CICCategoryCard_categoryItem_edit
      : styles.CICCategoryCard_categoryItem;
    const itemSpanClassName = classnames(
      styles.CICCategoryCard_categoryItem_content,
      {
        [styles.CICCategoryCard_categoryItem_content_uncheck]:
          !isEdit && !item.isChecked,
      },
    );
    const checkBoxId = `${id}-${item.cicCategoryItemId}`;
    return (
      <label className={itemClassName} key={checkBoxId} htmlFor={checkBoxId}>
        {isEdit ? (
          <Checkbox
            id={checkBoxId}
            checked={item.isChecked}
            onChange={(checkBoxStatus) =>
              this._handleCheckBoxChecked(
                id,
                item.cicCategoryItemId,
                checkBoxStatus,
              )
            }
          />
        ) : (
          ""
        )}
        <span className={itemSpanClassName}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.cicCategoryItemName) }} />
      </label>
    );
  }

  _handleCheckBoxChecked(id, itemId, checkBoxStatus) {
    ReactGA.event({
      category: "Covered in Class",
      action: "Clicked checkbox",
      label: `Clicked checkbox for ${itemId}`,
    });
    this.props.onItemCheck(id, itemId, checkBoxStatus);
  }

  render() {
    return (
      <div
        className={classnames(
          styles.CICCategoryCard,
          testClass("cic-category-card"),
        )}
      >
        <PageCard className={styles.CICCategoryCard_card}>
          <PageCard.Heading text={this.props.title} />
          <PageCard.Content>
            <div className={styles.CICCategoryCard_container}>
              {this._renderCategories()}
            </div>
          </PageCard.Content>
        </PageCard>
      </div>
    );
  }
}

CICCategoryCard.propTypes = {
  title: PropTypes.string.isRequired,
  categoriesList: PropTypes.shape({
    map: PropTypes.func.isRequired,
  }).isRequired,
  isEdit: PropTypes.bool,
  id: PropTypes.number,
  onItemCheck: PropTypes.func,
  onFreeTextChange: PropTypes.func,
};

export default CICCategoryCard;



// WEBPACK FOOTER //
// ./components/CICCategoryCard/index.jsx